var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionBase',{attrs:{"question":_vm.question,"errors":[..._vm.serverErrors, ..._vm.jsErrors],"valid":_vm.isValid}},[_c('document-request',{attrs:{"request":_vm.data,"transaction":_vm.form,"showDescription":false},on:{"saved":function($event){_vm.data = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }